var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"outer",class:{completed: _vm.completed}},[_c('div',{staticClass:"inner",style:({width: ((_vm.completed ? 100 : _vm.normProgress) + "%")})})]),(_vm.hasMessage)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }